export var ConnectionErrorCodes;
(function (ConnectionErrorCodes) {
    ConnectionErrorCodes["BadRequest"] = "connection.badRequest";
    ConnectionErrorCodes["InvalidConnection"] = "connection.invalid";
    // Google Auth Errors
    ConnectionErrorCodes["InvalidGoogleAccessCode"] = "connection.oauth.google.InvalidAccessCode";
    ConnectionErrorCodes["GoogleInsufficientPermissionsCode"] = "connection.oauth.google.InsufficientPermissionsCode";
    // Connection Auth Errors
    ConnectionErrorCodes["OAuthInvalidCode"] = "connection.oauth.InvalidCode";
    ConnectionErrorCodes["OAuthInvalidNonce"] = "connection.oauth.InvalidNonce";
    ConnectionErrorCodes["OAuthTokenInvalid"] = "connection.oauth.TokenInvalid";
    // oauth_client_credentials (OAuth1) and oauth_client_code (OAuth2) Errors
    ConnectionErrorCodes["OAuthEmptyAuthUrl"] = "connection.oauth.EmptyAuthUrl";
    ConnectionErrorCodes["OAuthEmptyClientID"] = "connection.oauth.EmptyClientID";
    ConnectionErrorCodes["OAuthEmptyClientSecret"] = "connection.oauth.EmptyClientSecret";
    ConnectionErrorCodes["OAuthEmptyRefreshToken"] = "connection.oauth.EmptyRefreshToken";
    ConnectionErrorCodes["OAuthEmptyTokenUrl"] = "connection.oauth.EmptyTokenUrl";
    ConnectionErrorCodes["OAuthFailedToUpdateAccessToken"] = "connection.oauth.FailedToUpdateAccessToken";
    ConnectionErrorCodes["OAuthMissingAccessToken"] = "connection.oauth.MissingAccessToken";
    ConnectionErrorCodes["OAuthMissingAuthUrl"] = "connection.oauth.MissingAuthUrl";
    ConnectionErrorCodes["OAuthMissingClientID"] = "connection.oauth.MissingClientID";
    ConnectionErrorCodes["OAuthMissingClientSecret"] = "connection.oauth.MissingClientSecret";
    ConnectionErrorCodes["OAuthMissingRefreshToken"] = "connection.oauth.MissingRefreshToken";
    ConnectionErrorCodes["OAuthMissingTokenUrl"] = "connection.oauth.MissingTokenUrl";
    // NonOAuth Credential Errors
    ConnectionErrorCodes["NonOAuthIncorrectCredentials"] = "connection.NonOAuth.IncorrectCredentials";
    ConnectionErrorCodes["HmacVerificationFailed"] = "connection.oauth.HmacVerificationFailed";
    // Snowflake Errors
    ConnectionErrorCodes["SnowflakeFreeTrialEnded"] = "connection.snowflake.FreeTrialEnded";
    ConnectionErrorCodes["SnowflakeIncorrectUrl"] = "connection.snowflake.IncorrectUrl";
    ConnectionErrorCodes["SnowflakeIncorrectUsernamePassword"] = "connection.snowflake.IncorrectUsernamePassword";
    ConnectionErrorCodes["SnowflakeNetworkError"] = "connection.snowflake.NetworkError";
    ConnectionErrorCodes["SnowflakeBadRole"] = "connection.snowflake.BadRole";
    ConnectionErrorCodes["SnowflakeInvalidDatabaseName"] = "connection.snowflake.InvalidDatabaseName";
    ConnectionErrorCodes["SnowflakeInvalidWareHouse"] = "connection.snowflake.InvalidWareHouse";
    // MsSql Errors
    ConnectionErrorCodes["MsSqlIncorrectCredentials"] = "connection.msSql.IncorrectCredentials";
    // AmazonS3 Errors
    ConnectionErrorCodes["AmazonS3RoleAssumptionFailed"] = "connection.amazonS3.RoleAssumptionFailed";
    // Sftp Errors
    ConnectionErrorCodes["SftpConnectionFailed"] = "connection.sftp.ConnectionFailed";
    // Tableau Errors
    ConnectionErrorCodes["TableauInvalidCredentials"] = "connection.tableau.InvalidCredentials";
    // Dynamics Errors
    ConnectionErrorCodes["DynamicsInvalidUrl"] = "connection.dynamics.InvalidUrl";
    ConnectionErrorCodes["DynamicsClientSecretExpired"] = "connection.dynamics.ClientSecretExpired";
    // Gong Errors
    ConnectionErrorCodes["GongInvalidAccessKey"] = "connection.gong.InvalidAccessKey";
    // SalesForce
    ConnectionErrorCodes["SalesForceOauthTokenRevoked"] = "connection.salesforce.OauthTokenRevoked";
})(ConnectionErrorCodes || (ConnectionErrorCodes = {}));
//# sourceMappingURL=connectionErrorCodes.js.map